"use client"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { Button } from "@/Components/ui/button"
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/Components/ui/form"
import { Input } from "@/Components/ui/input"

import { Workstream } from "./Plan"
import { useContext, useEffect } from 'react'
import { PlanBuilderContext } from './Plan'
import { Workflow } from "lucide-react"

const formSchema = z.object({
    name: z.string()
        .min(1, {
            message: "Workstream name is required",
        })
        .max(30, {
            message: "Workstream name must be less than 30 characters",
        })
});

interface WorkPackageFormProps {
    workstream: Workstream
}

const FrmWorkstream = ({ workstream }: WorkPackageFormProps) => {
    const props = useContext(PlanBuilderContext);

    const { reset, ...form } = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            name: workstream.name,
        },
    });

    useEffect(() => {
        reset({
            name: workstream.name,
        });
        setTimeout(() => form.setFocus("name"), 0);
    }, [workstream, reset]);

    function onSubmit(data: z.infer<typeof formSchema>) {
        const updatedWorkstream: Workstream = {
            ...data,
            id: workstream.id,
            name: data.name,
            active: workstream.active,
            projectId: workstream.projectId,
            workPackages: workstream.workPackages,
        };
        props.updateWorkstream(workstream.id, updatedWorkstream)
    }

    return (
        <Form {...form} reset={reset}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <FormField
                    control={form.control}
                    name="name"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Name</FormLabel>
                            <FormControl>
                                <Input placeholder="Name" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <Button type="submit"><Workflow />Update Workstream</Button>
            </form>
        </Form>
    )
}

export default FrmWorkstream